"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

var _colorInput = _interopRequireDefault(require("./color-input"));

var _colorUtils = require("./color-utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // 根据一个颜色获取画板右上角颜色


var getCornerColor = function getCornerColor(rgb) {
  var arr = [{
    key: 'r',
    val: rgb[0]
  }, {
    key: 'g',
    val: rgb[1]
  }, {
    key: 'b',
    val: rgb[2]
  }];
  arr.sort(function (m, n) {
    return m.val - n.val;
  });
  var max = arr[2].key;
  var mid = arr[1].key;
  var min = arr[0].key;
  var color = {};
  color[min] = 0;
  color[mid] = arr[1].val + 255 - arr[2].val - arr[0].val;
  color[max] = 255;
  return [color.r, color.g, color.b];
};

var ColorPalette = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(ColorPalette, _KZUIComponent);

  var _super = _createSuper(ColorPalette);

  function ColorPalette(props) {
    var _this;

    _classCallCheck(this, ColorPalette);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isPressStrap", void 0);

    _defineProperty(_assertThisInitialized(_this), "paletteCtx", void 0);

    _defineProperty(_assertThisInitialized(_this), "strapCtx", void 0);

    _defineProperty(_assertThisInitialized(_this), "paletteCanvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "strapCanvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "isPressPalette", void 0);

    _this.autoBind('initPalette', 'initPaletteStrap', 'handlePaletteCanvasMouseDown', 'handlePaletteCanvasMouseMove', 'handlePaletteCanvasMouseUp', 'handlePaletteCanvasMouseOut', 'handlePaletteCanvasClick', 'handleStrapCanvasMouseDown', 'handleStrapCanvasMouseMove', 'handleStrapCanvasMouseUp', 'handleStrapCanvasMouseOut', 'handleStrapCanvasClick', 'handleClickPalette', 'handleInputChange', 'getPosition', 'rgbToHex');

    _this.isPressStrap = false;
    _this.isPressPalette = false;
    _this.paletteCtx = null;
    _this.strapCtx = null;
    return _this;
  }

  _createClass(ColorPalette, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      // console.log('initStateFromProps', props);
      var state;
      var rgb = (0, _colorUtils.HEXToRGB)(props.hex);

      if (props.type === 'simple') {
        state = {
          rgb: rgb,
          a: props.a,
          hex: props.hex,
          height: 60,
          width: 214,
          strapHeight: 12
        };
      } else {
        state = {
          rgb: rgb,
          a: props.a,
          hex: props.hex,
          height: 130,
          width: 210,
          strapHeight: 12
        };
      } // TODO need to be changed


      if (!this.state) {
        this.state = state;
      }

      var _this$getPosition = this.getPosition(rgb),
          cursorLeft = _this$getPosition.cursorLeft,
          pointTop = _this$getPosition.pointTop,
          pointLeft = _this$getPosition.pointLeft;

      return Object.assign({}, state, {
        cursorLeft: cursorLeft,
        pointTop: pointTop,
        pointLeft: pointLeft
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initPalette(this.state.rgb);
      this.initPaletteStrap();
    } // 在画板完成更新时触发onchange事件

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // console.log('didupdate');
      // 若prop发生了变话，则说明更新由外部传入了新的色值触发，则需要重新更新palette状态
      // 否则说明更新是由内部input或者canvas状态发生变化引起的，此时不需要重新更新
      if (prevProps.hex !== this.props.hex) {
        this.initPalette(this.state.rgb);
      }
    }
  }, {
    key: "initPalette",
    value: function initPalette(rgb) {
      this.paletteCtx = this.paletteCanvas.getContext('2d');
      this.setPaletteStatus(rgb);
    }
  }, {
    key: "getPosition",
    value: function getPosition(rgb) {
      var cornerRgb = getCornerColor(rgb);
      var arr = [{
        key: 'r',
        val: rgb[0]
      }, {
        key: 'g',
        val: rgb[1]
      }, {
        key: 'b',
        val: rgb[2]
      }];
      arr.sort(function (m, n) {
        return m.val - n.val;
      });
      var max = arr[2].key;
      var min = arr[0].key;
      var left;

      switch (min + max) {
        case 'br':
          left = cornerRgb[1] / 255 * 0.17;
          break;

        case 'bg':
          left = 0.34 - cornerRgb[0] / 255 * 0.17;
          break;

        case 'rg':
          left = cornerRgb[2] / 255 * 0.17 + 0.34;
          break;

        case 'rb':
          left = 0.68 - cornerRgb[1] / 255 * 0.17;
          break;

        case 'gb':
          left = cornerRgb[0] / 255 * 0.17 + 0.68;
          break;

        case 'gr':
          left = 1 - cornerRgb[2] / 255 * 0.15;
          break;

        default:
          left = 0;
          break;
      }

      var cursorLeft = "".concat(parseInt(String(left * this.state.width), 10), "px");
      var pointTop = "".concat(parseInt(String((1 - arr[2].val / 255) * this.state.height), 10), "px");
      var pointLeft = "".concat(parseInt(String((1 - arr[0].val / arr[2].val) * this.state.width), 10), "px");
      return {
        cursorLeft: cursorLeft,
        pointTop: pointTop,
        pointLeft: pointLeft
      };
    }
  }, {
    key: "setPaletteStatus",
    value: function setPaletteStatus(rgb) {
      // console.log('setPaletteStatus: ', rgb, RGBToHEX(rgb));
      var cornerRgb = getCornerColor(rgb);
      var x = 0;
      var y = 0;
      var w = this.state.width;
      var h = this.state.height;
      var unitI = this.state.height / 255;
      var r;
      var g;
      var b;

      for (var i = 0; i < h; i += unitI) {
        var lg6 = this.paletteCtx.createLinearGradient(x, y + i, x + w, y + i); // 左侧边缘色彩

        b = Math.floor(255 - i * 255 / h);
        r = b;
        g = b;
        lg6.addColorStop(0, "rgb(".concat(r, ",").concat(g, ",").concat(b, ")")); // 右侧边缘色彩,因为i被等分了，所以需要反转单位

        r = cornerRgb[0] - i * 255 / h;
        g = cornerRgb[1] - i * 255 / h;
        b = cornerRgb[2] - i * 255 / h; // 保证不能小于0，因为是减法，所以也不可能大于 255

        r = r < 0 ? 0 : r;
        g = g < 0 ? 0 : g;
        b = b < 0 ? 0 : b; // rgb 函数只接受整数

        r = Math.floor(r) || 0;
        g = Math.floor(g) || 0;
        b = Math.floor(b) || 0;
        lg6.addColorStop(1, "rgb(".concat(r, ",").concat(g, ",").concat(b, ")"));
        this.paletteCtx.strokeStyle = lg6;
        this.paletteCtx.beginPath();
        this.paletteCtx.moveTo(x, y + i);
        this.paletteCtx.lineTo(x + w, y + i);
        this.paletteCtx.stroke();
      }
    } // 当输入框内容发生变化时, 与画板prop发生变化处理方式一致，所有需要绘制的地方都需要重绘。

  }, {
    key: "handleInputChange",
    value: function handleInputChange(rgb, hex, a) {
      var _this2 = this;

      var _this$getPosition2 = this.getPosition(rgb),
          cursorLeft = _this$getPosition2.cursorLeft,
          pointTop = _this$getPosition2.pointTop,
          pointLeft = _this$getPosition2.pointLeft;

      this.setState({
        rgb: rgb,
        hex: hex,
        a: a,
        cursorLeft: cursorLeft,
        pointTop: pointTop,
        pointLeft: pointLeft
      }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(_this2.state.hex, _this2.state.a);
        }
      });
      this.setPaletteStatus(rgb);
    }
  }, {
    key: "initPaletteStrap",
    value: function initPaletteStrap() {
      var h = this.state.strapHeight;
      var w = this.state.width;
      this.strapCtx = this.strapCanvas.getContext('2d');
      var grd = this.strapCtx.createLinearGradient(0, 0, w, 0);
      grd.addColorStop(0, '#FF0000');
      grd.addColorStop(0.17, '#FFFF00');
      grd.addColorStop(0.34, '#00FF00');
      grd.addColorStop(0.51, '#00FFFF');
      grd.addColorStop(0.68, '#0000FF');
      grd.addColorStop(0.85, '#FF00FF');
      grd.addColorStop(1, '#FF0000');
      this.strapCtx.fillStyle = grd;
      this.strapCtx.fillRect(0, 0, w, h);
    } // 上方大cavans相关事件

  }, {
    key: "handlePaletteCanvasMouseDown",
    value: function handlePaletteCanvasMouseDown() {
      this.isPressPalette = true;
    }
  }, {
    key: "handlePaletteCanvasMouseMove",
    value: function handlePaletteCanvasMouseMove(e) {
      if (this.isPressPalette) {
        this.handleClickPalette(e, 'palette');
      }
    }
  }, {
    key: "handlePaletteCanvasMouseUp",
    value: function handlePaletteCanvasMouseUp() {
      this.isPressPalette = false;
    }
  }, {
    key: "handlePaletteCanvasMouseOut",
    value: function handlePaletteCanvasMouseOut() {
      this.isPressPalette = false;
    }
  }, {
    key: "handlePaletteCanvasClick",
    value: function handlePaletteCanvasClick(e) {
      this.handleClickPalette(e, 'palette');
    } // 条形canvas相关事件

  }, {
    key: "handleStrapCanvasMouseDown",
    value: function handleStrapCanvasMouseDown() {
      this.isPressStrap = true;
    }
  }, {
    key: "handleStrapCanvasMouseMove",
    value: function handleStrapCanvasMouseMove(e) {
      if (this.isPressStrap) {
        this.handleClickPalette(e, 'strap');
      }
    }
  }, {
    key: "handleStrapCanvasMouseUp",
    value: function handleStrapCanvasMouseUp() {
      this.isPressStrap = false;
    }
  }, {
    key: "handleStrapCanvasMouseOut",
    value: function handleStrapCanvasMouseOut() {
      this.isPressStrap = false;
    }
  }, {
    key: "handleStrapCanvasClick",
    value: function handleStrapCanvasClick(e) {
      this.handleClickPalette(e, 'strap');
    } // 点击大画板的时候只需要更圆点的位置, 点击条形画板时需要重绘大画板，并更新圆点与条形版指针位置

  }, {
    key: "handleClickPalette",
    value: function handleClickPalette(e, type) {
      var _this3 = this; // console.log(e.nativeEvent, 'click事件');


      var ctx = type === 'palette' ? this.paletteCtx : this.strapCtx;
      e.preventDefault();
      var nativeEvent = e.nativeEvent;
      var data = ctx.getImageData(nativeEvent.offsetX, nativeEvent.offsetY, 1, 1);

      var _data$data = _slicedToArray(data.data, 3),
          r = _data$data[0],
          g = _data$data[1],
          b = _data$data[2];

      var rgb = [r, g, b];

      if (type === 'strap') {
        this.setPaletteStatus(rgb);
      }

      var _this$getPosition3 = this.getPosition(rgb),
          cursorLeft = _this$getPosition3.cursorLeft,
          pointTop = _this$getPosition3.pointTop,
          pointLeft = _this$getPosition3.pointLeft;

      this.setState({
        rgb: rgb,
        hex: (0, _colorUtils.RGBToHEX)(rgb),
        cursorLeft: type === 'strap' ? cursorLeft : this.state.cursorLeft,
        pointTop: pointTop,
        pointLeft: pointLeft
      }, function () {
        if (_this3.props.onChange) {
          _this3.props.onChange(_this3.state.hex, _this3.state.a);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var clsPrefix = 'kui-color-picker';
      var cls = (0, _classnames["default"])("".concat(clsPrefix, "-palette"));
      var typeClassName = "".concat(clsPrefix, "-cpe-container ").concat(clsPrefix, "-cpe-").concat(this.props.type);
      var cursorStyle = {
        left: this.state.cursorLeft
      };
      var pointStyle = {
        left: this.state.pointLeft,
        top: this.state.pointTop
      };
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, /*#__PURE__*/React.createElement("div", {
        className: typeClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cpe-main")
      }, /*#__PURE__*/React.createElement("canvas", {
        onClick: this.handlePaletteCanvasClick,
        onMouseDown: this.handlePaletteCanvasMouseDown,
        onMouseUp: this.handlePaletteCanvasMouseUp,
        onMouseMove: this.handlePaletteCanvasMouseMove,
        onMouseOut: this.handlePaletteCanvasMouseOut,
        width: this.state.width,
        height: this.state.height,
        ref: function ref(canvas) {
          _this4.paletteCanvas = canvas;
        },
        className: "".concat(clsPrefix, "-cpe-main-canvas")
      }), /*#__PURE__*/React.createElement("i", {
        className: "".concat(clsPrefix, "-cpe-point"),
        style: pointStyle
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cpe-row")
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(clsPrefix, "-cpe-cursor"),
        style: cursorStyle
      }), /*#__PURE__*/React.createElement("canvas", {
        width: this.state.width,
        height: this.state.strapHeight,
        ref: function ref(canvas) {
          _this4.strapCanvas = canvas;
        },
        onClick: this.handleStrapCanvasClick,
        onMouseDown: this.handleStrapCanvasMouseDown,
        onMouseMove: this.handleStrapCanvasMouseMove,
        onMouseUp: this.handleStrapCanvasMouseUp,
        onMouseOut: this.handleStrapCanvasMouseOut,
        className: "".concat(clsPrefix, "-cpe-row-canvas")
      })), /*#__PURE__*/React.createElement(_colorInput["default"], {
        onChange: this.handleInputChange,
        rgb: this.state.rgb,
        hex: this.state.hex,
        a: this.state.a,
        type: this.props.type
      })));
    }
  }]);

  return ColorPalette;
}(_component["default"]);

_defineProperty(ColorPalette, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  type: 'simple',
  hex: '#ff0000',
  a: 100,
  onChange: null
}));

var _default = ColorPalette;
exports["default"] = _default;